import React from 'react';

import Footer from 'Components/Layouts/TopMenu/Footer';

import { asset } from 'Services/BaseHelpers';

export default function RegistrationLayout({ children, attending }) {
    if (attending){
        return (
            <div
                className="w-full min-h-screen flex flex-col bg-app-gray-landing font-gilroy font-bold"
            >
                <div
                    className="h-mobile-banner md:h-laptop-banner lg:h-banner w-full  flex flex-row"
                >
                    <div
                        className="hidden lg:flex w-1/2 inset-0  "
                    >
                        <img
                            alt=""
                            className="w-full max-h-full hidden lg:block"
                            src={asset('/images/pages/profile/profile-banner.png')}
                        />
                    </div>

                    <div
                        className="w-full lg:w-1/2  flex flex-col bg-app-yellow overflow-hidden"
                    >
                        <div>
                            <img
                                alt=""
                                className="w-40 float-right max-h-96 m-5 absolute right-5"
                                src={asset('/images/logo.png')}
                            />
                        </div>
                        <div
                            className={"text-white flex flex-col font-gilroy font-thin max-h-banner my-auto flex"}
                        >
                            <div
                                className={"text-8xl md:text-reg-banner-smaller xl:text-reg-banner-large 2xl:text-reg-banner w-full text-center xl:text-right 2xl:mt-10 clear-both gap-0 font-medium self-end mr-5"}
                            >
                                Thanks
                            <div
                                className={"text-3xl xl:text-6xl text-white font-gilroy font-thin text-center xl:text-right  mr-0 lg:mr-12 mt-0 xl:-mt-10 font-medium"}
                            >
                                for registering
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div
                     className="w-full max-w-4xl mx-auto px-6 lg:px-0 flex-1 my-5 md:my-10"
                 >
                    {children}
                </div>

{/*
                <Footer />
*/}
            </div>
        )
    } else {
        return (
            <div
                className="w-full min-h-screen flex flex-col bg-app-gray-landing font-gilroy font-bold"
            >
                <div
                    className="h-1/3 max-h-[20em] w-full  flex flex-row"
                >
                    <div
                        className="w-1/2 inset-0 hidden lg:flex "
                    >
                        <img
                            alt=""
                            className="w-full max-h-96"
                            src={asset('/images/pages/profile/swimmer.png')}
                        />
                    </div>

                    <div
                        className="w-full lg:w-1/2  flex bg-app-pink"
                    >
                        <div
                            className={"w-full h-full"}
                        >
                            <img
                                alt=""
                                className="w-40 float-right max-h-96 m-5"
                                src={asset('/images/logo-yellow.png')}
                            />

                            <div
                                className={"flex max-h-[20em] text-4xl lg:text-9xl text-center text-app-yellow-reg font-gilroy font-thin h-full -mt-5"}
                            >
                                <p
                                    className={"self-end"}
                                >
                                    Registration
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className={"bg-app-gray-banner p-10 text-app-yellow-reg w-screen text-center text-xl"}
                >
                    <p>
                        Date: Wednesday 25th October 2023 at 3pm
                    </p>
                </div>

                <div
                    className="w-full max-w-4xl mx-auto px-6 lg:px-0 flex-1 my-5 md:my-10"
                >
                    {children}
                </div>

{/*
                <Footer />
*/}
            </div>
        )
    }
};
